const permissionSets = new Map();

const digital = 'com.sinclair.digital';
const facade = `${digital}.facade`;
// HOME PAGE
// View Package List Page & Weather List Page
permissionSets.set('packages.view', [`${facade}.story.read-all-stories`]);

// View All Properties
permissionSets.set('properties.view', [`${facade}.site.read-all`]);

// View Media List Page
permissionSets.set('media.view', [`${facade}.video-wrapper.read-all-videos`]);

// View Moderation Page - NOT YET IMPLEMENTED
permissionSets.set('moderation.view', [`${facade}.moderation.advanced-search-moderation`]);

// LIVESTREAM VIEW
permissionSets.set('livestream.view', [`${facade}.frontend-permissions.live-stream-read`]);

// LIVESTREAM CONTROL
permissionSets.set('livestream.control', [`${facade}.frontend-permissions.live-stream-control`]);

// View Reports List Page
permissionSets.set('metrics.view', [`${digital}.metrics.sell-through-metrics.read-sell-through-aggregate`]);

// View User Administration Page
permissionSets.set('user-admin.view', [`${facade}.advanced-user.read-user`]);

// PACKAGE LIST VIEW
// Search Package List Page & Weather List Page
permissionSets.set('packages.search', [`${facade}.story.read-all-stories`]);

// Create Story, Alert, and Weather Packages
permissionSets.set('package.create.story', [`${facade}.story.create-story`]);
permissionSets.set('package.create.alert', [`${facade}.alert.create-alert`]);
permissionSets.set('package.create.weather', [`${facade}.weather.create-weather`]);
permissionSets.set('package.create.bio', [`${facade}.biography.create-biography`]);

// PACKAGE VIEW
// View Story, Alert, Bio, and Weather Packages
permissionSets.set('package.view.story', [`${facade}.story.read-story`]);
permissionSets.set('package.view.alert', [`${facade}.alert.read-alert`]);
permissionSets.set('package.view.weather', [`${facade}.weather.read-weather`]);
permissionSets.set('package.view.bio', [`${facade}.biography.read-biography`]);

// Save Story, Alert, Bio, and Weather Packages
permissionSets.set('package.save.story', [`${facade}.story.update-story`]);
permissionSets.set('package.save.alert', [`${facade}.alert.update-alert`]);
permissionSets.set('package.save.weather', [`${facade}.weather.update-weather`]);
permissionSets.set('package.save.bio', [`${facade}.biography.update-biography`]);

// Publish Story, Alert, Bio, and Weather Packages
permissionSets.set('package.publish.story', [`${facade}.story.publish-story`]);
permissionSets.set('package.publish.alert', [`${facade}.alert.publish-alert`]);
permissionSets.set('package.publish.weather', [`${facade}.weather.publish-weather`]);
permissionSets.set('package.publish.bio', [`${facade}.biography.publish-biography`]);

// View Story Package Versions
permissionSets.set('package.versions.view', [`${facade}.story.read-versions`]);

// Save Package with new Media
permissionSets.set('package.add-media', [`${facade}.video-wrapper.update-story-with-video`]);

// Add Media to Story Package
permissionSets.set('package.update-media', [`${facade}.video-wrapper.update-video-in-story`]);

// Delete Media from Story Package
permissionSets.set('package.remove-media', [`${facade}.video-wrapper.delete-video-from-story`]);

const event = `${digital}.event.event-package`;
permissionSets.set('package.create.event', [`${event}.create-event-package`]);
permissionSets.set('package.view.event', [`${event}.read-event-package`]);
permissionSets.set('package.save.event', [`${event}.update-event-package`]);
permissionSets.set('package.publish.event', [`${event}.publish-event-package`]);

// SYNDICATION
// Search Properties
permissionSets.set('property.search', [`${facade}.site.search-sites-by-name`]);

// Search Sections
permissionSets.set('section.search', [`${facade}.section-property.search`]);

// MEDIA LIST VIEW
// Upload Media
permissionSets.set('media.upload', [
    `${facade}.image-wrapper.create-image`,
    `${facade}.video-wrapper.create-video`,
    `${facade}.video-wrapper.create-clip`,
    `${facade}.uploaded-images.upload-image`,
]);

// Edit Media
permissionSets.set('media.edit', [`${facade}.image-wrapper.update-image`, `${facade}.video-wrapper.update-video`]);

// Delete Media
permissionSets.set('media.delete', [`${facade}.video-wrapper.delete-video`]);

// Search Media
permissionSets.set('media.search', [`${facade}.video-wrapper.read-all-videos`]);

// PROPERTY LIST VIEW
permissionSets.set('property.view', [`${facade}.site.read`]);
permissionSets.set('property.create', [`${facade}.site.create`]);

// PROPERTY SETTINGS & SITE TREE VIEWS
permissionSets.set('property.edit', [`${facade}.site.update`]);

// SITE TREE VIEW
permissionSets.set('section.view', [`${facade}.section-property.read`]);
permissionSets.set('section.create', [`${facade}.section-property.create`]);
permissionSets.set('section.edit', [`${facade}.section-property.update`]);

// PRESENTATION - PAGE BUILDER
permissionSets.set('presentation.edit', [`${facade}.presentation.update`]);

// USER ADMINISTRATION VIEW
permissionSets.set('user-admin.create', [`${facade}.advanced-user.create-user`]);
permissionSets.set('user-admin.edit', [`${facade}.advanced-user.update-user`]);
permissionSets.set('user-admin.delete', [`${facade}.advanced-user.delete-user`]);

export default permissionSets;
